<template>
  <div v-loading="!complete">
<!--     <div class="h-60 bg-wh pos-rel top-title">
      <el-button style="position: absolute;top:12px;right:10px" type="primary" @click="add()" :loading="isLoading" v-if="!typeDetail">提交</el-button>
      <el-button style="position: absolute;top:12px;left:0px" @click="goback()" v-if="typeAdd">返回</el-button>
    </div> -->
    <div style="min-height:100px">
      <commonFormRender
        ref="form"
        :form="form"
        :formField="formField"
        :isReadonly="isReadonly"
        :complete="complete"
        :modelId="modelId"
        :groupList="groupList"
        :otherChange="otherChange"
        :selectChange="selectChange"
        :queryForignData="queryForignData">
        <div class="m-t-20 m-b-20">
          <el-button type="primary" @click="add" :loading="isLoading" v-if="!typeDetail">提交</el-button>
          <!-- <el-button @click="log">log</el-button> -->
          <div style="display:inline-block" v-if="level!=20">
            <el-button @click="goback" class='m-l-30' v-if="!isDialog">返回</el-button>
            <el-button @click="close" class='m-l-30' v-else>返回</el-button>
          </div>
        </div>
      </commonFormRender>
    </div>
  </div>
</template>

<style scoped>
.top-title {
  top: 0px;
  left: 0px;
  width: 100%
}
</style>

<script>
  import http from '../../../assets/js/http'
  import modelConfig from '../../../config/modelConfig'
  import flowConfig from '../../../config/flowConfig'
  import cmsConfig from '../../../config/cmsConfig'
  import commonFormRender from '../../Common/business/render/commonFormRender'
  import base64 from 'base-64'
  import utf8 from 'utf8'
  
  export default {
    name: 'formRender',
    props: {
      contentId: {
        type: Number,
        default() {
          return 0
        }
      },
      dealId: {
        type: Number,
        default() {
          return 0
        }
      },
      dataId: {
        type: Number,
        default() {
          return 0
        }
      },
      isDialog: {
        type: Boolean,
        default() {
          return false
        }
      },
      ids: null,
      level: {
        type: Number
      }
    },
    data() {
      return {
        // dataId: '',
        // dealId: '',
        // contentId: '',
        editors: [],
        isLoading: false,
        fieldData: [],
        formField: [],
        form: {},
        group: [], // 可见分组条件
        groupList: [], // 分组是否可见的判断
        host: '',
        fileType: [
          { id: 10, name: '图片' },
          { id: 20, name: '压缩文件' },
          { id: 30, name: 'word文档' },
          { id: 40, name: 'excel表格' },
          { id: 50, name: 'ppt幻灯片' },
          { id: 60, name: 'PDF' }
        ],
        complete: false,
        dealType: null, // 节点类型
        groups: [],
        fieldDataByName: {},
        isDepend: 0,
        default_user: [],
        newDefaultUser: {},
        dependConfig: [],
        queryData: '', // 跳转传来的参数
        keyData: {}, // 外键控件数据
        fieldNames: [],
        modelId: 0,
        queryForignData: [] // 外键被传参改变的数据
      }
    },
    created() {
      this.isLoading = true
      this.host = HOST
      if (this.$route.query.query) {
        this.queryData = decodeURIComponent(this.$route.query.query)
      }
      this.getCaseDetail()
    },
    methods: {
      isReadonly(item) {
        return item.default.field_auth == this.INPUT_READONLY ||  // 控件权限为只读
          this.dealType == this.OPERATION_DETAIL ||  //  当前页面为详情页
          item.disabled  // 当前控件被禁用
      },
      isHidden(item) {  // 控件不可见
        return item.default.field_auth == this.INPUT_EXIST
      },
      getCaseDetail() { // 获取配置和表数据
        this.complete = false
        let postData = ''
        if (this.dataId) {
          postData = {
            params: {
              id: this.dataId
            }
          }
        }
        // if (this.$route.query.dataId) {
        //   postData = {
        //     params: {
        //       id: this.$route.query.dataId
        //     }
        //   }
        // }
        let url = `cms/contents/${this.contentId}/deal/${this.dealId}`
        this.apiGet(url, postData).then((res) => {
          this.isLoading = false
          if (res.code == 200) {
            this.formField = res.data.formField
            this.fieldData = res.data.formField
            this.modelId = res.data.modelId
            if (res.data.dealConfig) {
              this.group = res.data.dealConfig.group
            }
            this.dealType = res.data.show_type
            this.isDepend = res.data.dealConfig.is_depend
            this.dependConfig = res.data.dealConfig.depend_config
            this.form = res.data.formData
            if (this.queryData) {
              this.setQueryData()
            }
            this.initData()
            this.initCancelData()
            this.initGroup(res.data)
            this.initDefautUser(res.data)
          } else {
            setTimeout(() => {
              this.goback()
            }, 1000)
            _g.dealError(this, res)
          }
        })
      },
      initData() {  // 根据配置设置验证规则；设置不可见控件的默认值；设置从属关系
        let needToJudgeDepent = []  // 需要判断是否具有从属关系的控件
        this.fieldData.forEach((item) => {
          let name = item.default.name // 字段名
          let title = item.default.title // 字段标题
          let isNeeded = item.default.is_needed // 是否必填
          let type = item.default.type // 控件类型
          this.fieldDataByName[name] = item
          item.options = this.$refs.form.getOptions(item)
          if (type == this.TYPE_RADIO ||
              type == this.TYPE_SELECT ||
              type == this.TYPE_CHECKBOX ||
              type == this.TYPE_FOREIGNKEY) {
            needToJudgeDepent.push(item)
          }
        })
        setTimeout(() => {
          _(needToJudgeDepent).forEach((res) => {
            // 注释
            // this.selectChange(res)
          })
        }, 1000)
        this.complete = true
      },
      initCancelData() {
        _(this.formField).forEach((res) => {
          if (res.default.way == 20) {
            this.fieldNames.push(res.default.name)
          }
        })
      },
      setQueryData() {  // 设置传参值
        let queryString = utf8.decode(base64.decode(this.queryData))
        let queryArr = queryString.split('&')
        _(queryArr).forEach((res) => {
          let keyValue = res.split('=')
          if (keyValue.length == 2) {
            _(this.formField).forEach((item, index) => {
              let name = item.default.name
              let type = item.default.type
              if (name == keyValue[0]) {
                let typeNumber = (type == this.TYPE_INPUTTEXT &&
                                  (item.input.write_type == this.TYPE_NUMBER ||
                                  item.input.write_type == this.TYPE_FLOATNUMBER ||
                                  item.input.write_type == this.TYPE_FORMULA)) ||
                                  type == this.TYPE_RADIO ||
                                  type == this.TYPE_SELECT ||
                                  type == this.TYPE_FOREIGNKEY
                if (type === this.TYPE_FOREIGNKEY) {
                  this.queryForignData.push(name)
                }
                if (typeNumber) {     // 数字类型
                  this.form[name] = parseFloat(keyValue[1])
                } else {
                  this.form[name] = keyValue[1]
                }
                return false
              }
            })
          }
        })
      },
      selectChange(item) {  // 单选、下拉、多选、外键值改变影响其他控件可选值或状态
        if (this.isDepend) {
          let name = item.default.name
          let type = item.default.type
          let targetArr = []
          _(this.dependConfig).forEach((res) => { // 遍历主从字段配置
            if (name == res.major_field && this.fieldDataByName[res.form_field]) {  // 该字段拥有可控制限制条件，且从属字段存在
              targetArr.push(res.form_field)  // 暂存该字段名
              let target = this.fieldDataByName[res.form_field]
              let targetType = target.default.type
              target.disabled = false
              let singleSuccess = false
              let multiSuccess = false
              if (type == this.TYPE_RADIO ||
                  type == this.TYPE_SELECT ||
                  type == this.TYPE_FOREIGNKEY) {
                singleSuccess = _.findIndex(res.major_value, (item) => {  // 单选值符合条件
                  return item === this.form[name]
                }) > -1
              } else if (type == this.TYPE_CHECKBOX) {
                // 去重合并后数组长度不等于两个数组长度相加，说明存在交集，符合条件
                let xorArr = _.xor(res.major_value, this.form[name])
                multiSuccess = this.form[name] && xorArr.length != res.major_value.length + this.form[name].length
              }
              if (singleSuccess || multiSuccess) {  // 符合从属限制条件，设置可选选项和是否禁用
                if (targetType == this.TYPE_FOREIGNKEY) { // 若是外键，则把id数组传给组件，让组件内部做筛选
                  target.options = res.can_select
                } else {
                  let newOptions = []
                  target.options = this.$refs.form.getOptions(target)  // 初始化所有选项，进行筛选
                  _(target.options).forEach((option) => { // 筛选符合条件的选项值
                    let optionSuccess = false
                    let optionValue = null
                    if (targetType == this.TYPE_RADIO ||
                        targetType == this.TYPE_SELECT) {  // 筛选单选符合条件的选项
                      optionValue = option.value
                    } else if (targetType == this.TYPE_CHECKBOX) {  // 筛选多选符合条件的选项
                      optionValue = option.name
                    }
                    if (optionValue !== null) {
                      optionSuccess = _.findIndex(res.can_select, (value) => {
                        return optionValue === value
                      }) > -1
                    }
                    if (optionSuccess) {
                      newOptions.push(option)
                    }
                  })
                  target.options = newOptions
                }
                if (res.is_limit) { // 限制开启，禁用控件
                  target.disabled = true
                  this.setIsNeed(target.default.name, false)
                } else {
                  target.disabled = false
                  this.setIsNeed(target.default.name, true)
                }
                this.resetFormData(target.default.name)
              } else {  // 不符合条件，解除从属字段的限制条件
                let notRepeat = Array.from(new Set(targetArr))
                if (targetArr.length == notRepeat.length) {  // 目标字段没有出现过（即没有被之前的条件设置过），恢复初始状态
                  target.disabled = false
                  this.setIsNeed(target.default.name, true)
                  let newOptions = []
                  newOptions = this.$refs.form.getOptions(target)
                  if (newOptions.length != target.options.length) {
                    this.resetFormData(target.default.name)
                  }
                  target.options = newOptions
                }
              }
            }
          })
        }
        this.setGroupshow()
      },
      otherChange() {
        this.setGroupshow()
      },
      uniqueArray(arr, key) {
        let result = []
        if (arr.length != 0) {
          result.push(arr[0])
          for (let i = 1; i < arr.length; i++) {
            let item = arr[i]
            let repeat = false
            for (let j = 0; j < result.length; j++) {
              if (item[key] == result[j][key]) {
                repeat = true
                break
              }
            }
            if (!repeat) {
              result.push(item)
            }
          }
        }
        return result
      },
      initDefautUser(data) {
        _(data.formField).forEach((res) => {
          if (res.default.way == 20) {
            let obj = {}
            obj[res.default.name] = res.default.field_default
            this.newDefaultUser[res.default.name] = res.default.field_default
            this.default_user.push(obj)
          }
        })
      },
      initGroup(data) {
        let groupList = []
        _(data.formData).forEach((res, $key) => {
          _(data.formField).forEach((rres) => {
            if ($key == rres.default.name) {
              groupList.push({
                group_id: rres.default.group_id,
                status: rres.default.status || 0,
                show: true
              })
              return
            }
          })
        })
        if (groupList.length) {
          this.groupList = this.uniqueArray(groupList, 'group_id') // 去重
        } else {
          this.groupList = []
        }
        this.setGroupshow()
      },
      setGroupshow() {
        _(this.groupList).forEach((res) => {
          if (res.status == 0) {
            res.show = true
          } else {
            if (this.group.length == 0) {
              res.show = false
            } else {
              _(this.group).forEach((grres) => {
                if (grres.group_id == res.group_id && grres.condition.length != 0) {
                  // 处理有分组条件的情况
                  // 存在分组条件
                  let showNum = 0
                  _(grres.condition).forEach((gcres) => {
                    _(this.form).forEach((fres, key) => {
                      if (gcres.name == key && String(gcres.value) == String(fres)) {
                        showNum++
                      }
                    })
                  })
                  if (showNum == grres.condition.length) {
                    res.show = true
                  } else {
                    res.show = false
                  }
                }
              })
            }
          }
        })
        this.$refs.form.updateRender(this.groupList)
      },
      setIsNeed(fieldName, required) { // 设置字段是否必填
        if (this.$refs.form.rules[fieldName] && this.$refs.form.rules[fieldName].length) {
          if (this.$refs.form.rules[fieldName][0].required !== undefined) {
            this.$refs.form.rules[fieldName][0].required = required
          }
        }
      },
      resetFormData(name) {
        if (this.form[name] instanceof Array) {  // 根据字段值类型置空
          this.form[name] = []
        } else {
          this.form[name] = ''
        }
      },
      setComplete(complete) {
        this.complete = complete
      },
      add() {
        let postData = _.cloneDeep(this.form)
        if (JSON.stringify(this.rules) != '{}') {
          this.$refs.form.validate((pass) => {
            if (pass) {
              this.post(postData)
            } else {
              _g.toastMsgForForm(this)
            }
          })
        } else {
          this.post(postData)
        }
      },
      post(postData) {
        if (this.dataId) {
          postData.id = this.dataId
        }
        // if (this.$route.query.dataId) {
        //   postData.id = this.$route.query.dataId
        // }
        if (this.default_user.length > 0) {
          postData._default_user = this.newDefaultUser
          _(this.fieldNames).forEach((res) => {
            delete postData[res]
          })
        }
        this.isLoading = !this.isLoading
        let url = ''
        if (this.ids) { // 批量处理数据
          postData.ids = this.ids
          url = `cms/contents/${this.contentId}/deal_child/${this.dealId}`
        } else {
          url = `cms/contents/${this.contentId}/deal/${this.dealId}`
        }
        this.apiPost(url, postData).then((res) => {
          if (res.code == 200) {
            _g.toastMsg(this, 'success', '提交成功')
            this.$emit('saveCallback', true, res)
          } else {
            _g.dealError(this, res)
          }
          this.isLoading = !this.isLoading
        })
      },
      goback() {
        router.go(-1)
      },
      close() {
        this.$emit('closeDialog')
      },
      log() {
        // console.log(this.form)
      }
    },
    computed: {
      typeDetail() {
        return this.dealType == this.OPERATION_DETAIL
      },
      typeAdd() {
        return this.dealType == this.OPERATION_ADD || this.dealType == this.OPERATION_EDIT || this.dealType == this.OPERATION_DETAIL
      }
    },
    watch: {
      'contentId'() {
        this.getCaseDetail()
      },
      'dealId'() {
        this.getCaseDetail()
      },
      'dataId'() {
        this.getCaseDetail()
      }
    },
    components: {
      commonFormRender
    },
    mixins: [http, modelConfig, flowConfig, cmsConfig]
  }
</script>


// WEBPACK FOOTER //
// formRender.vue?7bb82c6b